export enum OperatorMessages {
    ADDED = "operators.messages.added",
    EDITED = "operators.messages.edited"
}